<template>
  <div class="group-wrapper-subsection">
    <img class="image-2" alt="" src="/static/img/about-image.png" />
    <div class="group-3">
      <div class="text-wrapper-6">Development history</div>
      <div class="text-wrapper-7">发展历程</div>
    </div>
    <div class="history-range">2021 — 2026</div>
    <div class="timeline" aria-label="云帆培优 2021 至 2026 年发展历程">
      <article v-for="item in milestones" :key="item.year" class="timeline-item">
        <div class="timeline-marker" aria-hidden="true"><span /></div>
        <div class="timeline-year">{{ item.year }}</div>
        <p>{{ item.desc }}</p>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupWrapperSubsection",
  data() {
    return {
      milestones: [
        {
          year: "2021",
          desc: "创立“云帆培优”课外辅导，聚焦小班教学，延续优质线下教学模式，并配备直播课程。",
        },
        {
          year: "2022",
          desc: "开展小学、初中数学及初中物理业务，在两个教学点开课；坚持口碑招生，奠定发展基调。",
        },
        {
          year: "2023",
          desc: "新增恒大校区，多位优秀人才加入云帆，在读学员突破一千人。",
        },
        {
          year: "2024",
          desc: "新增怀特商场校区，完善理科产品线，建立企业文化体系。",
        },
        {
          year: "2025",
          desc: "新增合作路校区；课程覆盖小学、初中、高中数学，以及初中、高中物理。",
        },
        {
          year: "2026",
          desc: "新增柿火广场校区，持续完善多学段理科课程与校区布局。",
        },
      ],
    };
  },
};
</script>

<style scoped>
.group-wrapper-subsection {
  background:
    radial-gradient(circle at 84% 18%, rgba(48, 154, 226, 0.18), transparent 30%),
    #0b1d3c;
  height: 956px;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 4705px;
  width: 1920px;
}

.image-2 {
  bottom: 0;
  height: 240px;
  left: 0;
  mix-blend-mode: lighten;
  opacity: 0.42;
  position: absolute;
  width: 1920px;
}

.group-3 {
  height: 63px;
  left: 186px;
  position: absolute;
  top: 103px;
  width: 474px;
}

.text-wrapper-6 {
  align-items: center;
  color: #ffffff1a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 40px;
  justify-content: center;
  left: 0;
  line-height: 40px;
  position: absolute;
  top: 23px;
  white-space: nowrap;
}

.text-wrapper-7 {
  align-items: center;
  color: #ffffff;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 40px;
  justify-content: center;
  left: 0;
  line-height: 40px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.history-range {
  color: rgba(255, 255, 255, 0.52);
  font-family: "Poppins", Helvetica;
  font-size: 18px;
  letter-spacing: 2px;
  position: absolute;
  right: 174px;
  top: 128px;
}

.timeline {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  left: 128px;
  position: absolute;
  top: 292px;
  width: 1664px;
}

.timeline::before {
  background: linear-gradient(90deg, #35b6f5 0%, rgba(80, 227, 194, 0.8) 100%);
  content: "";
  height: 2px;
  left: 21px;
  position: absolute;
  right: 21px;
  top: 20px;
}

.timeline-item {
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.045));
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  min-height: 330px;
  padding: 72px 24px 28px;
  position: relative;
}

.timeline-item:nth-child(even) {
  margin-top: 54px;
}

.timeline-marker {
  align-items: center;
  background: #0b1d3c;
  border: 2px solid #52d7ff;
  border-radius: 50%;
  box-shadow: 0 0 0 8px rgba(82, 215, 255, 0.12);
  display: flex;
  height: 34px;
  justify-content: center;
  left: 22px;
  position: absolute;
  top: 4px;
  width: 34px;
  z-index: 1;
}

.timeline-marker span {
  background: #50e3c2;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.timeline-year {
  color: #ffffff;
  font-family: "Poppins", Helvetica;
  font-size: 38px;
  font-weight: 700;
  line-height: 48px;
}

.timeline-item p {
  color: rgba(255, 255, 255, 0.76);
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 17px;
  line-height: 31px;
  margin: 18px 0 0;
}
</style>
